import './About.css'

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>회사 소개</h1>
            <p className="hero-subtitle">
              Literacy Intelligence for the Next Generation
            </p>
          </div>
        </div>
      </section>

      {/* Company Info */}
      <section className="company-info">
        <div className="container">
          <div className="info-content">
            <h2 className="section-title">NEXPA Inc.</h2>
            <div className="company-description">
              <p>
                NEXPA(주식회사 넥스파)는 AI 기반 문해력 분석 기술을 중심으로, 학습 미래를 새롭게 설계하는 
                지식 테크 기업입니다. 사용자 참여형 게임 경험을 통해 학습의 몰입도와 정밀한 리터러시 평가를 실현합니다.
              </p>
              <p>
                교육을 기술로, 기술을 새로운 경험으로 이어가는 것이 NEXPA의 미션입니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="mission-values">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-card card">
              <h3>NEXPA의 미션</h3>
              <p>
              NEXPA는 미래의 지식을 설계합니다. 초등부터 성인까지 전 생애 주기에 걸친 
                문해력 증진을 목표로, AI 기술과 게임화 전략을 결합한 독창적인 평가 시스템을 개발하고 있습니다.
              </p>
            </div>
            
            <div className="mission-card card">
              <h3>NEXPA의 비전</h3>
              <p>
                세상을 읽는 힘, 문해력을 혁신합니다. AI 기반 독서 이해력 진단 및 피드백 시스템으로 
                학습 데이터 기반 맞춤형 학습 여정을 제공하며, 글로벌 확산 가능한 다국어 평가 콘텐츠를 구축합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Company History */}
      <section className="company-history">
        <div className="container">
          <h2 className="section-title">회사 연혁</h2>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">2024</div>
              <div className="timeline-content">
                <h4>NEXPA Inc. 설립</h4>
                <p>AI 기반 문해력 평가 플랫폼 개발 시작</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2025</div>
              <div className="timeline-content">
                <h4>LIDIA System 개발</h4>
                <p>AI 기반 맞춤형 독서 평가 시스템 출시</p>
              </div>
            </div>
            
            <div className="timeline-item">
              <div className="timeline-year">2026</div>
              <div className="timeline-content">
                <h4>NEXPA MAP 출시</h4>
                <p>지식 확장 맵 기반 학습 도구 제공, LIDIA System 고도화</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      <section className="leadership">
        <div className="container">
          <h2 className="section-title">경영진</h2>
          <div className="leadership-grid">
            <div className="leader-card card">
              <div className="leader-info">
                <p className="leader-description" style={{marginBottom: '0'}}>
                  AI 기반 교육 기술 분야의 전문가로, NEXPA의 비전과 전략을 이끌고 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="contact-info">
        <div className="container">
          <div className="contact-content card">
            <h2>연락처 정보</h2>
            <div className="contact-details">
              <div className="contact-item">
                <h4>회사명</h4>
                <p>주식회사 넥스파 (NEXPA Inc.)</p>
              </div>
              <div className="contact-item">
                <h4>주소</h4>
                <p>서울시 서초구 강남대로 107길 21, 2층</p>
              </div>
              <div className="contact-item">
                <h4>연락처</h4>
                <p>02-6207-7400</p>
                <p>ceo@nexpa-ai.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About 